import { FunctionComponent, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useGetUserapiAdminTestsGetTestByIdByTestIdQuery } from "../app/services/meseeknaApi"
import HeaderSection from "../components/header-section"
import ProgressDialogBox from "../components/progress-dialog-box"
import { StepComponent } from "../components/progress-steps"
import Sidebar from "../features/sidebar/components/sidebar"
import { Simulation } from "../features/simulation/types"
import { dangerousInnerHtmlObj } from "../utils/sanitizer"
import { simulationSlice } from "../features/simulation/simulationSlice"
import { useTypedDispatch } from "../app/store"

const SimulationIntro: FunctionComponent = () => {
  const navigate = useNavigate()
  const { testId, runId } = useParams()
  const {
    data: simResponse,
    isSuccess: simLoadIsSuccess,
    isFetching: simLoadIsFetching,
  } = useGetUserapiAdminTestsGetTestByIdByTestIdQuery({
    testId: testId ?? "",
  })
  const [simData, setSimData] = useState<Simulation>()
  const dispatch = useTypedDispatch()

  const navigateToSimulation = () => {
    navigate(`/simulations/${testId}/${runId}`)
  }

  const buttons = [
    {
      text: "Next",
      callback: navigateToSimulation,
    },
  ]

  useEffect(() => {
    dispatch(simulationSlice.actions.changeSteps(1))
    if (simLoadIsSuccess && simResponse) {
      const actualSimData = simResponse.data
      if (actualSimData && actualSimData.length > 0) {
        setSimData(actualSimData[0])
      }
    }
  }, [simLoadIsSuccess, simResponse])

  return (
    <div className="relative bg-base-white w-full h-[100dvh] flex flex-row items-start justify-start font-text-md-regular">
      <Sidebar />

      <div className="w-full h-[100dvh] flex-1 flex flex-col">
        <HeaderSection hideBreadcrumbs hideHelpIcon hideProfileIcon />
        <StepComponent />
        {simLoadIsFetching && <div>Loading...</div>}
        {!simLoadIsSuccess && !simLoadIsFetching && (
          <div>Failed to load simulation</div>
        )}
        {simLoadIsSuccess && simResponse && (
          <ProgressDialogBox title="Scenario" buttons={buttons}>
            <div className="flex flex-1 space-y-4">
              <div
                dangerouslySetInnerHTML={dangerousInnerHtmlObj(
                  simData?.manualDescription,
                )}
              />
            </div>
          </ProgressDialogBox>
        )}
      </div>
    </div>
  )
}

export default SimulationIntro
